import { generateApiUrl } from "@/shared/utils";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const createInterviewDoneAttachment = async (interviewDoneId, files) => {
  try {
    const url = generateApiUrl(
      ["interview", "interviewDoneAttachment"],
      [interviewDoneId]
    );
    const payload = { files };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getMyQuestionSuggest = async (id) => {
  try {
    const url = generateApiUrl(["interview", "my_question_suggest_id"], [id]);
    const response = await httpService.get(url);

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateMyQuestionSuggest = async (id, payload) => {
  try {
    const url = generateApiUrl(["interview", "my_question_suggest_id"], [id]);
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
